import { combineReducers } from 'redux';
import authReducer from './authReducer';
import dashboardReducer from './dashboardReducer';
import breadcrumbReducer from './breadCrumbReducer';
import businessUnitReducer from './businessUnitReducer';
import charityActivityReducer from './charityActivityReducer';
import auditLogReducer from './auditLogReducer';
import userReducer from './userReducer';

const allReducers = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  breadcrumbs: breadcrumbReducer,
  businessUnit: businessUnitReducer,
  charitableActivity: charityActivityReducer,
  auditLog: auditLogReducer,
  userReducer: userReducer
})

export default allReducers;
